import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { Avatar } from '../user/Avatar';
class DriverStatusCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { driver: { _id, coords }, selected, } = this.props;
            this.props.onDriverCardClick({
                id: _id,
                selected: !selected,
                coords,
            });
        };
    }
    render() {
        const { driver: { _id, available, fullName, equipmentClassLabel }, selected, t, } = this.props;
        const driverCardClassName = classnames({
            'driver-card': true,
        });
        const driverCardImageClassName = classnames({
            'driver-card__image': true,
            'driver-card__image--active': available,
            'driver-card__image--selected': selected,
            'rounded-full': true,
        });
        const status = available ? t('ON_DUTY') : t('OFF_DUTY');
        const tooltip = (React.createElement(Tooltip, { id: `tooltip-${_id}` },
            React.createElement("p", null, fullName),
            React.createElement("p", null, status),
            React.createElement("p", null,
                React.createElement("span", null,
                    t('VEHICLE'),
                    ": "),
                equipmentClassLabel)));
        return (React.createElement("div", { className: driverCardClassName, onClick: this.handleClick, onKeyPress: this.handleClick },
            React.createElement(OverlayTrigger, { placement: "bottom", overlay: tooltip },
                React.createElement("div", null,
                    React.createElement(Avatar, { key: _id, userId: _id, className: driverCardImageClassName, style: { width: 50, height: 50 } })))));
    }
}
DriverStatusCard.propTypes = {
    driver: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        fullName: PropTypes.string.isRequired,
        available: PropTypes.bool.isRequired,
        equipmentClassLabel: PropTypes.string.isRequired,
        coords: PropTypes.arrayOf(PropTypes.number).isRequired,
    }).isRequired,
    onDriverCardClick: PropTypes.func.isRequired,
    selected: PropTypes.bool,
};
DriverStatusCard.defaultProps = {
    selected: false,
};
export default withTranslation()(DriverStatusCard);
